import { ReportStationSummaryDtoSchema } from "@report/data/dto/report-station.dto.ts";
import * as z from "zod";

const ReportTracksStatusEnumDtoSchema = z
    .enum(["PARADA", "DESPLAZAMIENTO"])
    .nullable();

const ReportTracksDtoSchema = z
    .object({
        timestamp: z.number(),
        status: ReportTracksStatusEnumDtoSchema,
        position: z.string().trim(),
        latitude: z.string().trim(),
        longitude: z.string().trim(),
        values: z.record(z.string(), z.union([z.number(), z.string().trim()])),
    })
    .readonly();

const ReportRouteGpsStationDtoSchema = z
    .object({
        roads: z.array(z.string().trim()),
        station: ReportStationSummaryDtoSchema,
        tracks: z.array(ReportTracksDtoSchema),
    })
    .readonly();

export const ReportRouteGpsDtoSchema = z
    .object({
        // eslint-disable-next-line id-denylist
        data: z.record(z.string(), ReportRouteGpsStationDtoSchema),
    })
    .readonly();

export type ReportRouteGpsDto = z.output<typeof ReportRouteGpsDtoSchema>;
